module.exports = __webpack_public_path__ + "static/media/www.loylyhelsinki.fi.e74d41bd.png";